import PassportAdminReviewItem from "./PassportAdminReviewItem";
export default PassportAdminReviewItem;